import type { ClipMetadata } from '../types.ts/story';

/**
 * PLAT-12077 — Clip Producer saves its clips as metadata only
 * (`isLightweightClip`); the editable source is built when the clip is first
 * opened. Until then there is nothing to render, and publishing one fails in
 * the browser before any render is requested.
 *
 * Ready once the flag is cleared (the expansion was saved) or the in-memory
 * clip already holds an expanded source (the preview expanded it but has not
 * saved yet).
 */
export function isClipAwaitingExpansion(clip: {
  clipJson?: ClipMetadata | null;
  videoSource?: { elements?: unknown } | null;
}): boolean {
  return (
    clip.clipJson?.isLightweightClip === true &&
    !Array.isArray(clip.videoSource?.elements)
  );
}
